module.exports = __webpack_public_path__ + "static/logo-ae191224f9dbcd5a2a2ec2bfc302e3d7.png";